import React from "react";
import BaseModal from "./BaseModal";
import { mdiAccountQuestion } from "@mdi/js";

/**
 * Shown when a guest enters an email that already has a guest-shadow profile
 * at this org but the typed name differs from the name on file. Pure guests
 * have no account to log into — this modal asks which name to use on the
 * booking, and the choice is threaded into the reservation as overrideStoredName.
 *
 * Props:
 *   isOpen        - bool
 *   onClose       - () => void  (cancels — caller should also clear or re-prompt)
 *   storedName    - { firstName, lastName }  (name currently on the profile)
 *   typedName     - { firstName, lastName }  (what the user just entered)
 *   onChoose      - (useNewName: boolean) => void   true = override, false = keep stored
 */
const EmailNameReconcileModal = ({ isOpen, onClose, storedName, typedName, onChoose }) => {
    if (!isOpen) return null;

    const storedFull = `${storedName?.firstName || ""} ${storedName?.lastName || ""}`.trim();
    const typedFull = `${typedName?.firstName || ""} ${typedName?.lastName || ""}`.trim();

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            title="We have you on file"
            icon={mdiAccountQuestion}
            maxWidth={460}
            footer={
                <>
                    <button
                        className="base-modal-cancel-btn"
                        onClick={() => onChoose(false)}
                    >
                        Keep "{storedFull}"
                    </button>
                    <button
                        className="base-modal-save-btn"
                        onClick={() => onChoose(true)}
                    >
                        Use "{typedFull}"
                    </button>
                </>
            }
        >
            <p style={{ marginBottom: "1rem", color: "var(--dl-color-text-muted)", fontSize: "0.9rem" }}>
                That email is already on file with this instructor under the name <strong>{storedFull}</strong>, but you've typed <strong>{typedFull}</strong>.
            </p>
            <p style={{ margin: 0, color: "var(--dl-color-text-muted)", fontSize: "0.875rem" }}>
                Which name should we use on this booking? Choosing "Use {typedName?.firstName || "new"}" will update your profile with the instructor.
            </p>
        </BaseModal>
    );
};

export default EmailNameReconcileModal;
